import useVehicle from './useVehicle';

const useUnitLocation = (): string | null => {
  const { data: vehicle } = useVehicle();
  return vehicle?.operatingCountry ?? null;
};

export default useUnitLocation;
